import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalChangeActiveCustomerProps extends ModalEditComponentProps { }

const ModalChangeActiveWCal: React.FC<ModalChangeActiveCustomerProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivateWCal {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalDeleteWCal {...{ setOpened, onSubmit, allRowData }} />
    }
}

interface ModalReactivateWCalProps extends ModalEditComponentProps { }

const ModalReactivateWCal: React.FC<ModalReactivateWCalProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/workingCalendar/updateWCalParentForActive',
        data: {
            id: allRowData?.id,
            active: true
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureReactiveWCal', '¿Seguro que quieres reactivar este calendario?'),
            subtitle: t('onceReactivatedAbleInCalendarList', 'Una vez reactivado volverá a aparecer en el listado de calendarios'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}


interface ModalDeleteWCalProps extends ModalEditComponentProps { }

const ModalDeleteWCal: React.FC<ModalDeleteWCalProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/workingCalendar/updateWCalParentForActive',
        data: {
            id: allRowData?.id,
            active: false
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDisableWCal', '¿Seguro que quieres desactivar este calendario?'),
            subtitle: t('onceDisabledCanRecoverM', 'Una vez desactivado podrás recuperarlo'),
            buttonAccept: t('disable', 'Desactivar'),
        }} />
    )
}

export default ModalChangeActiveWCal